import React, { Component } from "react"
import Typography from "@mui/material/Typography"
import { sanitizeYaml } from "../../utilities"
import linkifyHtml from "linkify-html"

export default class UserDifferentClues extends Component {
  render() {
    const { text, clue } = this.props

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          maxWidth: "min(960px, calc(100% - 64px))",
          margin: "0 32px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            textTransform: "none",
            padding: "32px 48px",
            borderRadius: "24px",
            background: "rgba(255, 255, 255, .8)",
            backdropFilter: "blur(16px)",
            marginBottom: "16px",
          }}
        >
          <Typography
            variant="h3"
            style={{ overflow: "hidden", textOverflow: "ellipsis" }}
            dangerouslySetInnerHTML={{
              __html: linkifyHtml(sanitizeYaml(clue), {
                target: "_blank",
                attributes: {
                  class: "underlineOnHover",
                },
              }),
            }}
          />
        </div>
        {text && (
          <div
            style={{
              textAlign: "center",
              textTransform: "none",
              padding: "32px 48px",
              borderRadius: "24px",
              background: "rgba(255, 255, 255, .8)",
              backdropFilter: "blur(16px)",
              marginBottom: "16px",
            }}
          >
            <Typography
              variant="h3"
              style={{
                fontWeight: 300,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              dangerouslySetInnerHTML={{
                __html: linkifyHtml(sanitizeYaml(text), {
                  target: "_blank",
                  attributes: {
                    class: "underlineOnHover",
                  },
                }),
              }}
            />
          </div>
        )}
      </div>
    )
  }
}
